import React, { useEffect, useState, Fragment } from 'react'
import {Button, Card, Col, Container, Form, Row, Modal} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import {FaSearch} from 'react-icons/fa'
import { formato_monto, isValidParam } from '../../common/Formatos'
import { CarpetaDigitalComponent } from '../..'

const Formulario = ({handleClose}) => {
    const [showCarpeta, setShowCarpeta] = useState(false)
   const data_recepciona = useSelector((state) => state.casoGeneralReducer)
   const { llaves} = data_recepciona
   const data_ingresos = useSelector((state) => state.ingresoRecobroReducer)
   const { cfg_form35, datosRecobro} = data_ingresos
   const handleShowCarpeta = () => setShowCarpeta(true)
   const handleCloseCarpeta= () => setShowCarpeta(false)

   const [formaPago, setFormaPago ]=useState('')
   const [recobroCuotas, setRecobroCuotas ]=useState('')


   useEffect(()=>{ 

    let formaPago = datosRecobro && isValidParam(datosRecobro.datosRecobro['formaPago']) ? datosRecobro.datosRecobro['formaPago'] : ''
    let montoRecobro = datosRecobro && isValidParam(datosRecobro.datosRecobro['montoRecobro']) ? datosRecobro.datosRecobro['montoRecobro'] : 0
    let montoPie = datosRecobro && isValidParam(datosRecobro.datosRecobro['montoPagoPie']) ? datosRecobro.datosRecobro['montoPagoPie'] : 0

    setFormaPago(formaPago);
    setRecobroCuotas(montoRecobro - montoPie);
    
  },[datosRecobro])

  return (
    <>
 <style type='text/css'>
 {`
    .btn-carpeta {
        background-color: #F0AD3E;
        color: #FFFFFF;
        width: 140px;
        
      }
      .btn-carpeta:hover{
          background-color:#e1b97f;
          color: #FFFFFF;
  
      }    
 `}
    </style>
    <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">      
        
        <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
          idCaso={llaves && llaves['idCaso']}
          idImplicado={llaves && llaves['idImplicado']}
          idOrganizacionCaso={llaves && llaves['idOrgCaso']}
            prototipo={2}
            
          />     
     
    </Modal>
    <Container> 
        <Card >
          <Card.Header
            className='mt-0 mb-0'
            as='h6'
            style={{ backgroundColor: '#4F517A', color: 'white' }}
          >
            {cfg_form35
              ? cfg_form35.cfg_form35['modalconsultarecobros-title']
              : ''} 
          </Card.Header>
         
            
              {cfg_form35? (
                <div style={{border:'2px solid #4F517A', marginTop:'10px', borderRadius:'10px', marginLeft:'10px', marginRight:'10px'}} >
                 <Container>
                 <Container>
                  <Row >
                    <Col >
                      <Form.Label
                        className='mb-2 mt-3'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form35.cfg_form35[
                            'modalconsultarecobros-lbl-ambito'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        { isValidParam(datosRecobro?.datosRecobro['glosaAmbitoGestion']) ? datosRecobro?.datosRecobro['glosaAmbitoGestion'] : '' }  
                      </Form.Text>
                    </Col>
                    <Col>
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form35.cfg_form35[
                            'modalconsultarecobros-grilla-moneda'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        { isValidParam(datosRecobro?.datosRecobro['glosaMoneda']) ? datosRecobro?.datosRecobro['glosaMoneda'] : '' }                      
                      </Form.Text>
                   </Col>
                    <Col>
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form35.cfg_form35[
                            'modalconsultarecobros-lbl-mtoneto'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      { isValidParam(datosRecobro?.datosRecobro['montoNeto']) ? formato_monto(datosRecobro.datosRecobro['montoNeto']) : '' }   
                      </Form.Text>                     
                    </Col>
                    <Col >
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form35.cfg_form35[
                            'modalconsultarecobros-lbl-porcrecup'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        { isValidParam(datosRecobro?.datosRecobro['porcRecupero']) ? datosRecobro?.datosRecobro['porcRecupero'] : '' }                      
                      </Form.Text>
                    </Col>
                    <Col>
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form35.cfg_form35[
                            'modalconsultarecobros-lbl-mtorecobro'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        { isValidParam(datosRecobro?.datosRecobro['montoRecobro']) ? formato_monto(datosRecobro.datosRecobro['montoRecobro']) : '' }                        
                      </Form.Text>
                    </Col>         
                    <Col >
                        <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '16px' }} >
                          {cfg_form35.cfg_form35['modalconsultarecobros-lbl-glosaformapago']}
                        </Form.Label>{' '}
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          { isValidParam(datosRecobro?.datosRecobro['glosaFormaPago']) ? datosRecobro?.datosRecobro['glosaFormaPago'] : '' }
                        </Form.Text>
                      </Col>                                               
                  </Row>
                  </Container>
                 <Row>                    
                    <Col md='6'  xl='2' sm='4' lg='2' >
                    <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '18px' }}>
                        {cfg_form35.cfg_form35['modalconsultarecobros-subtitle']}
                      </Form.Label>
                    </Col>
                    <Col md='8' xl='10' sm='8' lg='10'>                    
                      <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>
                    </Col>
                 </Row>
                 {formaPago && formaPago == 253002 ? (
                  <div>
                    <Row >
                      <Col >
                        <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '16px' }} >
                          {cfg_form35.cfg_form35['modalconsultarecobros-lbl-mediopagopie']}
                        </Form.Label>{' '}
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          { isValidParam(datosRecobro?.datosRecobro['medioPagoPie']) ? datosRecobro?.datosRecobro['medioPagoPie'] : '' }
                        </Form.Text>
                      </Col>
                      <Col >
                        <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '16px' }} >
                          {cfg_form35.cfg_form35['modalconsultarecobros-lbl-banco']}
                        </Form.Label>{' '}
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        { isValidParam(datosRecobro?.datosRecobro['banco']) ? datosRecobro?.datosRecobro['banco'] : '' }
                        </Form.Text>
                      </Col>
                      <Col >
                        <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '16px' }} >
                          {cfg_form35.cfg_form35['modalconsultarecobros-lbl-nrocheque']}
                        </Form.Label>{' '}
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          { isValidParam(datosRecobro?.datosRecobro['nroChequeTrans']) ? datosRecobro?.datosRecobro['nroChequeTrans'] : '' }
                        </Form.Text>
                      </Col>
                      <Col >
                        <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '16px' }} >
                          {cfg_form35.cfg_form35['modalconsultarecobros-lbl-montopagopie']}
                        </Form.Label>{' '}
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          { isValidParam(datosRecobro?.datosRecobro['montoPagoPie']) ? formato_monto(datosRecobro?.datosRecobro['montoPagoPie']) : '' }
                        </Form.Text>
                      </Col>
                      <Col >
                        <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '16px' }} >
                          {cfg_form35.cfg_form35['modalconsultarecobros-lbl-fechapagopie']}
                        </Form.Label>{' '}
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          { isValidParam(datosRecobro?.datosRecobro['fechaPagoPieFormat']) ? datosRecobro?.datosRecobro['fechaPagoPieFormat'] : '' }
                        </Form.Text>
                      </Col>
                      <Col >
                        <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '16px' }} >
                          {cfg_form35.cfg_form35['modalconsultarecobros-lbl-recobrocuotas']}
                        </Form.Label>{' '}
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          {recobroCuotas ? formato_monto(recobroCuotas) : ''}
                        </Form.Text>
                      </Col>
                    </Row>
                    <Row>                    
                        
                        <Col md='12' xl='12' sm='8' lg='12'>                    
                          <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>
                        </Col>
                    </Row>
                  </div>
                 ):('')}
                 <Container>
                  <Row className='mb-3'>
                    <Col md='2'>
                      <Form.Label
                        className='mb-2 mt-3'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form35.cfg_form35[
                            'modalconsultarecobros-lbl-idconvenio'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosRecobro && 
                                datosRecobro.datosRecobro   ['idConvenio'] !== undefined &&
                                datosRecobro.datosRecobro   ['idConvenio'] !== null &&
                                datosRecobro.datosRecobro   ['idConvenio'] !== ''
                                ? datosRecobro.datosRecobro ['idConvenio']
                                : ''}
                </Form.Text>
                    </Col>
                    <Col md='3'>
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form35.cfg_form35[
                            'modalconsultarecobros-lbl-fecprimpago'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosRecobro &&
                datosRecobro.datosRecobro['fechaPrimerPago'] !== undefined &&
                datosRecobro.datosRecobro['fechaPrimerPago'] !== null &&
                datosRecobro.datosRecobro['fechaPrimerPago'] !== ''
                ? datosRecobro.datosRecobro['fechaPrimerPago']
                : ''}
                </Form.Text>
                   </Col>
                    <Col md='2'>
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form35.cfg_form35[
                            'modalconsultarecobros-grilla-moneda'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosRecobro &&
                datosRecobro.datosRecobro['moneda'] !== undefined &&
                datosRecobro.datosRecobro['moneda'] !== null &&
                datosRecobro.datosRecobro['moneda'] !== ''
                ? datosRecobro.datosRecobro['moneda']
                : ''}
                </Form.Text>
                   </Col>
                    
                    
                  
                    <Col md='3'>
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form35.cfg_form35[
                            'modalconsultarecobros-lbl-recobroing'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosRecobro &&
                datosRecobro.datosRecobro['recobroIngresado'] !== undefined &&
                datosRecobro.datosRecobro['recobroIngresado'] !== null &&
                datosRecobro.datosRecobro['recobroIngresado'] !== ''
                ? formato_monto(datosRecobro.datosRecobro['recobroIngresado'])
                : ''}
                </Form.Text>
                     
                    </Col>
                    
                    <Col md='2'>
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form35.cfg_form35[
                            'modalconsultarecobros-lbl-saldo'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosRecobro &&
                        datosRecobro.datosRecobro['saldoRecobro'] !== undefined &&
                        datosRecobro.datosRecobro['saldoRecobro'] !== null &&
                        datosRecobro.datosRecobro['saldoRecobro'] !== ''
                        ? formato_monto(datosRecobro.datosRecobro['saldoRecobro'])
                        : ''}
                </Form.Text>
                    </Col>
               
                        
                   
                  </Row>

                  
                  </Container>
                 <Container>
                  <Row className='mb-3'>
                    <Col md='2'></Col>
                    <Col md='3'>
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form35.cfg_form35[
                            'modalconsultarecobros-lbl-fechpagofinal'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosRecobro &&
                datosRecobro.datosRecobro['fechaUltimoPago'] !== undefined &&
                datosRecobro.datosRecobro['fechaUltimoPago'] !== null &&
                datosRecobro.datosRecobro['fechaUltimoPago'] !== ''
                ? datosRecobro.datosRecobro['fechaUltimoPago']
                : ''}
                </Form.Text>
                   </Col>
                    <Col md='2'>
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form35.cfg_form35[
                            'modalconsultarecobros-lbl-cuotas'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3 mx-4' style={{ fontSize: '14px' }}>
                        {datosRecobro &&
                datosRecobro.datosRecobro['cuotas'] !== undefined &&
                datosRecobro.datosRecobro['cuotas'] !== null &&
                datosRecobro.datosRecobro['cuotas'] !== ''
                ? datosRecobro.datosRecobro['cuotas']
                : ''}
                </Form.Text>
                   </Col>
                    
                    
                  
                    <Col md='3'>
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form35.cfg_form35[
                            'modalconsultarecobros-lbl-cuotasvis'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Text className='mb-3 mx-4' style={{ fontSize: '14px' }}>
                        {datosRecobro &&
                datosRecobro.datosRecobro['cuotasVisadas'] !== undefined &&
                datosRecobro.datosRecobro['cuotasVisadas'] !== null &&
                datosRecobro.datosRecobro['cuotasVisadas'] !== ''
                ? formato_monto(datosRecobro.datosRecobro['cuotasVisadas'])
                : ''}
                </Form.Text>
                     
                    </Col>
                    
                    <Col md='2'>
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form35.cfg_form35[
                            'modalconsultarecobros-lbl-cuotaspend'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3 mx-4' style={{ fontSize: '14px' }}>
                        {datosRecobro &&
                        datosRecobro.datosRecobro['cuotasPendientes'] !== undefined &&
                        datosRecobro.datosRecobro['cuotasPendientes'] !== null &&
                        datosRecobro.datosRecobro['cuotasPendientes'] !== ''
                        ? formato_monto(datosRecobro.datosRecobro['cuotasPendientes'])
                        : ''}
                </Form.Text>
                    </Col>
               
                        
                   
                  </Row>

                  
                  </Container>
              
               </Container> 
                </div>
                
              ) : null}
           
           <Row >
                <Col className='d-flex align-items-end justify-content-end m-2'>
                <Button className='m-2 w-auto' variant='outline-info' onClick={handleClose}   >
                {cfg_form35 && cfg_form35.cfg_form35["modalconsultarecobros-btn-cerrar"]}
                
          </Button>
          
                
                <Button className='m-2 w-auto' variant='carpeta' onClick={handleShowCarpeta}   >
                {cfg_form35 && cfg_form35.cfg_form35["modalconsultarecobros-btn-carpeta"]}
                
          </Button>
          </Col>
           </Row>
     
      
   
          
        </Card>
        </Container> 
     
    
    </>
  )
}

export default Formulario
